export default __webpack_public_path__ + "static/media/player-jill-colour-mob.46258b1b.png";